module.exports = __webpack_public_path__ + "img/bg_qdq.c50fb81d.svg";